module.exports = __webpack_public_path__ + "img/product2.680f01af.png";